import { createFileRoute } from '@tanstack/react-router'
import { DevelopersPanel } from '../components/platform/SettingsPanels.tsx'

export const Route = createFileRoute('/_authed/_shell/settings/developers')({
  component: DevelopersPanel,
})
